module.exports = {
  EnrichedPDF: {
    Allow_fullscreen: "Permitir Pantalla Completa",
    Show_controls: "Mostrar Controles",
    URL: "URL",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    Coords: "Coordenadas",
    opacity: "Opacidad",
    padding: "Padding",
    empty_title: "Añade un PDF",
    empty_hint: "Sube un PDF desde Archivos o pega un enlace en el campo URL del panel derecho.",
    loading: "Cargando PDF…",
    unavailable_title: "Visor de PDF no disponible",
    unavailable_hint: "No se pudo cargar la librería de PDF. Actualiza la página.",
    PluginName: "Visor PDF",
    radius: "Radio",
    source: "Origen",
    message_mark_xyp:
      "Ha introducido un valor incorrecto. Debe introducir tres números separados por coma. Ej. 4.56,90.76,1",
    message_mark_percentage:
      "Ha introducido un valor incorrecto. Debe introducir un porcentaje entre 0 y 100. Ej. 45.66%",
  },
};
